import React, {useEffect, useState} from 'react'
import FlatList from 'flatlist-react'
import Loading from '../Loading/Loading'
import HttpRequest from '../../services/HttpRequest'
import Notify from '../../services/Notify'
import {Row} from 'react-bootstrap'
import {CustomCardFooter} from "./CustomCardFooter";

const httpRequest = new HttpRequest()

function CustomCardList({endpoint, sortParam, renderItems, pageSize = 10, flatListStyle, button, display}) {

  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [page, setPage] = useState(0)
  const [size, setsize] = useState(pageSize)
  const [hasMoreItems, setHasMoreItems] = useState(false)

  const loadItems = async () => {
    try {
      setIsLoading(true)
      const url = endpoint.includes("?") ? `${endpoint}&${getParams()}` : `${endpoint}?${getParams()}`
      const {number, totalPages, content} = await httpRequest.get(url)
      content.map((x, i) => {
        x.index = i
        return x
      })
      const newData = page === 0 ? content : [...data, ...content];
      setData(newData)
      setHasMoreItems(number < totalPages - 1)
    } catch (error) {
      Notify.error('Erro ao buscar itens', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    loadItems();
  }, [page]);

  useEffect(() => {
    setPage(0)
    loadItems()
  }, [endpoint])

  useEffect(() => {
    renderItems && renderItems(data)
  }, [data])
  const getParams = () => {
    const params = new URLSearchParams({})

    params.append('size', size)
    params.append('page', page)
    params.append('sort', sortParam)

    return params
  }

  const renderWhenEmpty = () => {
    return (
      <Row className="justify-content-center w-100 overflow-hidden">
        {data.length === 0 && isLoading ? <Loading/> : <h4>{"A lista está vazia"}</h4>}
      </Row>
    )
  }

  return (
    <div style={flatListStyle}>
      <FlatList
        list={data}
        renderItem={renderItems}
        renderWhenEmpty={renderWhenEmpty}
        hasMoreItems={hasMoreItems}
        loadMoreItems={() => !isLoading && loadItems()}
        paginationLoadingIndicator={<Loading/>}
        paginationLoadingIndicatorPosition="center"
        renderOnScroll
        display={display}
        horizontal={false}
      />
      {data.length > 0 && button && hasMoreItems &&
        <CustomCardFooter
          hasMoreItems={isLoading}
          onClick={() => setPage(page + 1)}
        />
      }
    </div>
  )
}

export default CustomCardList



// WEBPACK FOOTER //
// ./src/component/List/CustomCardList.js